import type { ComponentProps } from 'react';

const ArrowDownIcon = (props: ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#8C98AB"
      d="M9.88 11.453 16 17.56l6.12-6.107 1.88 1.88-8 8-8-8 1.88-1.88Z"
    />
  </svg>
);

export default ArrowDownIcon;
